import React from 'react';

const Loader = () => (
    <span className="loader">
        <span className="loader__dot" />
        <span className="loader__dot" />
        <span className="loader__dot" />
    </span>
);

export default Loader;



// WEBPACK FOOTER //
// ./resources/components/shop/components/Loader.jsx